import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompaniesComponent } from './containers/companies-house.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule, InputsModule, TableModule, IconsModule, ModalModule } from 'angular-bootstrap-md';

import * as fromCompanies from './store/companies-house.reducer';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CompaniesEffects } from './store/companies-house.effects';
import { CompaniesRoutingModule } from './companies-house-routing.module';
import { SharedModule } from '../shared/shared.module';
import { AngularMaterialModule } from '../angular-material.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatNativeDateModule } from '@angular/material/core';
import { DemoMaterialModule } from './material-module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CompaniesRoutingModule,
    AngularMaterialModule,
    ModalModule,
    FormsModule,
    DemoMaterialModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    MatTabsModule,
    ButtonsModule,
    InputsModule,
    IconsModule,
    TableModule,
    StoreModule.forFeature('companies', fromCompanies.companiesReducer),
    EffectsModule.forFeature([CompaniesEffects])
  ],
  declarations: [CompaniesComponent],
  exports: [CompaniesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CompaniesModule { }
